// D-037 c5.1 (Jun 22, PASTE #91 Option C): client-side helper that
// POSTs a magic-link lifecycle event to the audit-logging API.
// Fire-and-forget — audit-log failure must never break the auth
// flow.  Server-side SHA-256 hashes the email before persisting.

export type MagicLinkAuditEvent =
  | "requested"
  | "consumed"
  | "expired"
  | "failed"
  // D-037 c5.5 (Jun 23, PASTE #105): Device A's poll detected a
  // claim from another device.  Distinct from "consumed" (which
  // fires on the claimer's tab) — see the same-named action in
  // lib/aws/dynamodb/audit.ts.
  | "consumed_elsewhere";

export function logMagicLinkEvent(
  event: MagicLinkAuditEvent,
  email: string,
  reason?: string,
): void {
  // #462-C: provably non-blocking. Every path here is wrapped so a SYNCHRONOUS
  // throw (JSON.stringify on a hostile value, fetch missing in some webview,
  // keepalive unsupported) can NEVER propagate into the caller's sign-in flow.
  // The audit write remains best-effort and un-awaited - it must not change
  // whether a client signs in. (Root cause of #462 was never here, but this
  // removes any doubt that telemetry can gate auth.)
  try {
    if (typeof window === "undefined" || typeof fetch !== "function") return;
    // No await — best-effort; we never block the Cognito flow on the audit
    // table. Keepalive lets the request survive a page navigation (e.g. the
    // consumed event fires immediately before the dashboard redirect).
    void fetch("/api/auth/magic-link/audit", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ event, email, reason }),
      keepalive: true,
    }).catch(() => {
      /* swallow — audit miss tolerated */
    });
  } catch {
    /* swallow — telemetry must never affect the sign-in outcome */
  }
}
